import { FC } from 'react'
import { observer } from 'mobx-react'
import { IJobBase } from '@/types'
import { getJobThumbnail } from '@/utils'
import styles from './index.module.scss'

type Props = {
  job: IJobBase
}

export const JobHero: FC<Props> = observer(({ job }) => {
  return (
    <div className='container'>
      <div className={styles.container}>
        <img src={getJobThumbnail(job)} alt={job?.title} className='img-fluid' />
      </div>
    </div>
  )
})
